import { useToasts } from 'react-toast-notifications';
import { Typography } from '@mui/material';
import { updateConsentReferrerSharing } from '../../../redux/assessment';
import { useAppDispatch } from '../../../pages/assessment';
import { AssessmentButtons, AssessmentCard } from '../shared';

const ConsentReferrerSharing = () => {
  const dispatch = useAppDispatch();
  const { addToast } = useToasts();

  const onClickContinue = async (consentReferrerSharing: boolean) => {
    try {
      await dispatch(updateConsentReferrerSharing(consentReferrerSharing));
    } catch (e) {
      addToast(
        'Sorry, something went wrong. Please refresh the page and try again.',
        { appearance: 'error' }
      );
    }
  };

  const onClickConsent = async () => onClickContinue(true);
  const onClickDoesNotConsent = async () => onClickContinue(false);

  return (
    <>
      <AssessmentCard>
        <Typography paragraph>
          Sharing certain information can help all your doctors provide the best
          possible care.
        </Typography>
        <Typography paragraph>
          If you consent, we’d like to share the answers you provided in this
          form and a summary of your first visit, if you choose to have one.
          That summary can include a diagnosis and any medications we prescribe.
        </Typography>
        <Typography>
          If you do not consent, we'll only let your clinician know whether or
          not you complete their referral.
        </Typography>
      </AssessmentCard>
      <AssessmentButtons
        primary={{
          endIcon: null,
          children: 'Yes, share this',
          onClick: onClickConsent,
        }}
        secondary={{
          children: 'No, I do not consent',
          onClick: onClickDoesNotConsent,
        }}
      />
    </>
  );
};

export default ConsentReferrerSharing;
